module.exports = __webpack_public_path__ + "img/new-logout.fea5358d.svg";